/*
  Pile på produktbilledet (sections/main-product.liquid, .dms-gallery-nav).
  Klikker på forrige/næste synlige miniature, så temaets media-gallery.js skifter billedet
  (både på desktop og i mobilens swipe-galleri).
*/
(function () {
  if (window.__dmsGalleryNav) return;
  window.__dmsGalleryNav = true;

  document.addEventListener("click", function (event) {
    var arrow = event.target.closest && event.target.closest("[data-dms-gallery-nav]");
    if (!arrow) return;
    event.preventDefault();
    event.stopPropagation();

    var gallery = arrow.closest("media-gallery");
    if (!gallery) return;

    var thumbs = Array.prototype.filter.call(
      gallery.querySelectorAll(".product-media-thumbnail"),
      function (thumb) {
        return thumb.offsetParent !== null || getComputedStyle(thumb).display !== "none";
      }
    );
    if (thumbs.length < 2) return;

    var current = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains("is-active");
    });
    if (current < 0) current = 0;

    var step = arrow.dataset.dmsGalleryNav === "prev" ? -1 : 1;
    var next = (current + step + thumbs.length) % thumbs.length;
    var toggle = thumbs[next].querySelector("button");
    if (toggle) toggle.click();
  });
})();
